var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-prev",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.9 35.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4,17.9L19,3.6c1-1,1-2.1,0.3-2.9c-0.8-0.8-2.1-0.9-3-0.1 c0,0-0.1,0.1-0.1,0.1L0.7,16.1c-1,1-1,2.5-0.1,3.6l15.5,15.6c0.9,0.7,2.1,0.7,3,0.1c0.8-0.8,0.9-2.1,0.1-2.9c0,0,0,0,0,0L4.4,17.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.7837a09095b49914e8fb35295e411cf5.svg";
export { ForwardRef as ReactComponent };